var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDots(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 84,
    viewBox: "0 0 292 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 3C32 1.34315 30.6569 0 29 0C27.3431 0 26 1.34315 26 3C26 4.65685 27.3431 6 29 6C30.6569 6 32 4.65685 32 3Z",
    fill: "#00E9C8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58 3C58 1.34315 56.6569 0 55 0C53.3431 0 52 1.34315 52 3C52 4.65685 53.3431 6 55 6C56.6569 6 58 4.65685 58 3Z",
    fill: "#00E9C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3C0 4.65685 1.34315 6 3 6C4.65685 6 6 4.65685 6 3Z",
    fill: "#00E9C8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32 55C32 53.3431 30.6569 52 29 52C27.3431 52 26 53.3431 26 55C26 56.6569 27.3431 58 29 58C30.6569 58 32 56.6569 32 55Z",
    fill: "#00E9C8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58 55C58 53.3431 56.6569 52 55 52C53.3431 52 52 53.3431 52 55C52 56.6569 53.3431 58 55 58C56.6569 58 58 56.6569 58 55Z",
    fill: "#00E9C8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 55C6 53.3431 4.65685 52 3 52C1.34315 52 0 53.3431 0 55C0 56.6569 1.34315 58 3 58C4.65685 58 6 56.6569 6 55Z",
    fill: "#00E9C8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32 29C32 27.3431 30.6569 26 29 26C27.3431 26 26 27.3431 26 29C26 30.6569 27.3431 32 29 32C30.6569 32 32 30.6569 32 29Z",
    fill: "#00E9C8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58 29C58 27.3431 56.6569 26 55 26C53.3431 26 52 27.3431 52 29C52 30.6569 53.3431 32 55 32C56.6569 32 58 30.6569 58 29Z",
    fill: "#00E9C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6 29C6 27.3431 4.65685 26 3 26C1.34315 26 0 27.3431 0 29C0 30.6569 1.34315 32 3 32C4.65685 32 6 30.6569 6 29Z",
    fill: "#00E9C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M110 3C110 1.34315 108.657 0 107 0C105.343 0 104 1.34315 104 3C104 4.65685 105.343 6 107 6C108.657 6 110 4.65685 110 3Z",
    fill: "#00E9C8"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M136 3C136 1.34315 134.657 0 133 0C131.343 0 130 1.34315 130 3C130 4.65685 131.343 6 133 6C134.657 6 136 4.65685 136 3Z",
    fill: "#00E9C8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M84 3C84 1.34315 82.6569 0 81 0C79.3431 0 78 1.34315 78 3C78 4.65685 79.3431 6 81 6C82.6569 6 84 4.65685 84 3Z",
    fill: "#00E9C8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110 55C110 53.3431 108.657 52 107 52C105.343 52 104 53.3431 104 55C104 56.6569 105.343 58 107 58C108.657 58 110 56.6569 110 55Z",
    fill: "#00E9C8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M136 55C136 53.3431 134.657 52 133 52C131.343 52 130 53.3431 130 55C130 56.6569 131.343 58 133 58C134.657 58 136 56.6569 136 55Z",
    fill: "#00E9C8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M84 55C84 53.3431 82.6569 52 81 52C79.3431 52 78 53.3431 78 55C78 56.6569 79.3431 58 81 58C82.6569 58 84 56.6569 84 55Z",
    fill: "#00E9C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M110 29C110 27.3431 108.657 26 107 26C105.343 26 104 27.3431 104 29C104 30.6569 105.343 32 107 32C108.657 32 110 30.6569 110 29Z",
    fill: "#00E9C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M136 29C136 27.3431 134.657 26 133 26C131.343 26 130 27.3431 130 29C130 30.6569 131.343 32 133 32C134.657 32 136 30.6569 136 29Z",
    fill: "#00E9C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M84 29C84 27.3431 82.6569 26 81 26C79.3431 26 78 27.3431 78 29C78 30.6569 79.3431 32 81 32C82.6569 32 84 30.6569 84 29Z",
    fill: "#00E9C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M188 3C188 1.34315 186.657 0 185 0C183.343 0 182 1.34315 182 3C182 4.65685 183.343 6 185 6C186.657 6 188 4.65685 188 3Z",
    fill: "#00E9C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M214 3C214 1.34315 212.657 0 211 0C209.343 0 208 1.34315 208 3C208 4.65685 209.343 6 211 6C212.657 6 214 4.65685 214 3Z",
    fill: "#00E9C8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M162 3C162 1.34315 160.657 0 159 0C157.343 0 156 1.34315 156 3C156 4.65685 157.343 6 159 6C160.657 6 162 4.65685 162 3Z",
    fill: "#00E9C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M188 55C188 53.3431 186.657 52 185 52C183.343 52 182 53.3431 182 55C182 56.6569 183.343 58 185 58C186.657 58 188 56.6569 188 55Z",
    fill: "#00E9C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M214 55C214 53.3431 212.657 52 211 52C209.343 52 208 53.3431 208 55C208 56.6569 209.343 58 211 58C212.657 58 214 56.6569 214 55Z",
    fill: "#00E9C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M162 55C162 53.3431 160.657 52 159 52C157.343 52 156 53.3431 156 55C156 56.6569 157.343 58 159 58C160.657 58 162 56.6569 162 55Z",
    fill: "#00E9C8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M188 29C188 27.3431 186.657 26 185 26C183.343 26 182 27.3431 182 29C182 30.6569 183.343 32 185 32C186.657 32 188 30.6569 188 29Z",
    fill: "#00E9C8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M214 29C214 27.3431 212.657 26 211 26C209.343 26 208 27.3431 208 29C208 30.6569 209.343 32 211 32C212.657 32 214 30.6569 214 29Z",
    fill: "#00E9C8"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M162 29C162 27.3431 160.657 26 159 26C157.343 26 156 27.3431 156 29C156 30.6569 157.343 32 159 32C160.657 32 162 30.6569 162 29Z",
    fill: "#00E9C8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M266 3C266 1.34315 264.657 0 263 0C261.343 0 260 1.34315 260 3C260 4.65685 261.343 6 263 6C264.657 6 266 4.65685 266 3Z",
    fill: "#00E9C8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M292 3C292 1.34315 290.657 0 289 0C287.343 0 286 1.34315 286 3C286 4.65685 287.343 6 289 6C290.657 6 292 4.65685 292 3Z",
    fill: "#00E9C8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M240 3C240 1.34315 238.657 0 237 0C235.343 0 234 1.34315 234 3C234 4.65685 235.343 6 237 6C238.657 6 240 4.65685 240 3Z",
    fill: "#00E9C8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M266 55C266 53.3431 264.657 52 263 52C261.343 52 260 53.3431 260 55C260 56.6569 261.343 58 263 58C264.657 58 266 56.6569 266 55Z",
    fill: "#00E9C8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M292 55C292 53.3431 290.657 52 289 52C287.343 52 286 53.3431 286 55C286 56.6569 287.343 58 289 58C290.657 58 292 56.6569 292 55Z",
    fill: "#00E9C8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M240 55C240 53.3431 238.657 52 237 52C235.343 52 234 53.3431 234 55C234 56.6569 235.343 58 237 58C238.657 58 240 56.6569 240 55Z",
    fill: "#00E9C8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M32 81C32 79.3432 30.6569 78 29 78C27.3431 78 26 79.3432 26 81C26 82.6569 27.3431 84 29 84C30.6569 84 32 82.6569 32 81Z",
    fill: "#00E9C8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M58 81C58 79.3432 56.6569 78 55 78C53.3431 78 52 79.3432 52 81C52 82.6569 53.3431 84 55 84C56.6569 84 58 82.6569 58 81Z",
    fill: "#00E9C8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M6 81C6 79.3432 4.65685 78 3 78C1.34315 78 0 79.3432 0 81C0 82.6569 1.34315 84 3 84C4.65685 84 6 82.6569 6 81Z",
    fill: "#00E9C8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M110 81C110 79.3432 108.657 78 107 78C105.343 78 104 79.3432 104 81C104 82.6569 105.343 84 107 84C108.657 84 110 82.6569 110 81Z",
    fill: "#00E9C8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M136 81C136 79.3432 134.657 78 133 78C131.343 78 130 79.3432 130 81C130 82.6569 131.343 84 133 84C134.657 84 136 82.6569 136 81Z",
    fill: "#00E9C8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M84 81C84 79.3432 82.6569 78 81 78C79.3431 78 78 79.3432 78 81C78 82.6569 79.3431 84 81 84C82.6569 84 84 82.6569 84 81Z",
    fill: "#00E9C8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M188 81C188 79.3432 186.657 78 185 78C183.343 78 182 79.3432 182 81C182 82.6569 183.343 84 185 84C186.657 84 188 82.6569 188 81Z",
    fill: "#00E9C8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M214 81C214 79.3432 212.657 78 211 78C209.343 78 208 79.3432 208 81C208 82.6569 209.343 84 211 84C212.657 84 214 82.6569 214 81Z",
    fill: "#00E9C8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M162 81C162 79.3432 160.657 78 159 78C157.343 78 156 79.3432 156 81C156 82.6569 157.343 84 159 84C160.657 84 162 82.6569 162 81Z",
    fill: "#00E9C8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M266 81C266 79.3432 264.657 78 263 78C261.343 78 260 79.3432 260 81C260 82.6569 261.343 84 263 84C264.657 84 266 82.6569 266 81Z",
    fill: "#00E9C8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M292 81C292 79.3432 290.657 78 289 78C287.343 78 286 79.3432 286 81C286 82.6569 287.343 84 289 84C290.657 84 292 82.6569 292 81Z",
    fill: "#00E9C8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M240 81C240 79.3432 238.657 78 237 78C235.343 78 234 79.3432 234 81C234 82.6569 235.343 84 237 84C238.657 84 240 82.6569 240 81Z",
    fill: "#00E9C8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M266 29C266 27.3431 264.657 26 263 26C261.343 26 260 27.3431 260 29C260 30.6569 261.343 32 263 32C264.657 32 266 30.6569 266 29Z",
    fill: "#00E9C8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M292 29C292 27.3431 290.657 26 289 26C287.343 26 286 27.3431 286 29C286 30.6569 287.343 32 289 32C290.657 32 292 30.6569 292 29Z",
    fill: "#00E9C8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M240 29C240 27.3431 238.657 26 237 26C235.343 26 234 27.3431 234 29C234 30.6569 235.343 32 237 32C238.657 32 240 30.6569 240 29Z",
    fill: "#00E9C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.355d1b14ad1f0a1158aa17e35d76e6c3.svg";
export { ForwardRef as ReactComponent };